/* ==========================================================================
   SpotMyStuff — Add-to-Cart Toast
   Shows the pill toast from the Claude Design MCP handoff (component #20)
   in response to Horizon's own real cart-update event — never a
   simulated or assumed success.

   WHY THIS LIVES IN ITS OWN SECTION FILE, NOT INSIDE THE HERO OR STICKY
   BAR: unlike the Sticky Add-to-Cart Bar (which had to live inside the
   Hero panel's own .shopify-section for Horizon's IntersectionObserver
   lookup to find it), a `position: fixed` toast has no such constraint —
   it renders correctly from anywhere in the DOM. Keeping it as a fully
   separate section means this feature can be added, previewed, and (if
   ever needed) removed without touching the Hero section, the Sticky
   Add-to-Cart Bar, or any locked section, exactly as instructed.

   HOW THIS REUSES HORIZON'S REAL CART FLOW, NOT A DUPLICATE ONE:
     - It listens for `shopify:cart:lines-update` on `document` — the
       same real event Horizon's own cart-icon.js and cart-drawer.js
       listen for, and the same event both Horizon's native product-form
       submissions and this project's own custom /cart/add.js calls
       dispatch (assets/spotmystuff-hero-purchase-v2.js,
       assets/spotmystuff-sticky-cart.js). No new add-to-cart request is
       made here, and the toast never shows unless that event's own
       promise actually resolves without `didError` — i.e. only after a
       real, successful Shopify add.
     - It does not touch, wrap, or replace Horizon's cart drawer
       (assets/cart-drawer.js) or cart icon (assets/cart-icon.js) in any
       way — both keep running exactly as before. If the store's cart
       type is "drawer" with auto-open enabled, the drawer and this toast
       will both respond to the same real event, independently — that's
       expected, matches how Horizon's own cart-icon bubble animation
       already runs alongside the drawer today, and this file adds no
       listener that could conflict with either.
     - It does not touch checkout in any way.

   WHAT THE MESSAGE SHOWS: the handoff's own copy ("Added to cart — 2 ×
   Tracking Card") assumed one fixed product name and a numeric pack
   count. This page can add three different real packs (1/2/3 Cards, two
   of which are entirely different Shopify products), so the message
   uses the ACTIVE pack's own real, settings-driven name (the same
   already-rendered text the Sticky Add-to-Cart Bar reads for its own
   sync — see assets/spotmystuff-sticky-cart.js) instead of a hardcoded
   product name or a guessed quantity. On any other page without this
   Hero panel, it falls back to a generic "Added to cart" message rather
   than showing nothing.
   ========================================================================== */

(function () {
  'use strict';

  var TOAST_DURATION_MS = 2400; // matches the handoff's own script.js timing, unchanged

  function init() {
    var toast = document.getElementById('spotmystuff-cart-toast');
    if (!toast) return;

    var hideTimer = null;

    function activePackName() {
      var activePack = document.querySelector('.spotmystuff-hero-purchase-v2 [data-spotmystuff-pack].is-active');
      if (!activePack) return null;
      var nameEl = activePack.querySelector('.spotmystuff-hero-purchase-v2__pack-name > span');
      return nameEl ? nameEl.textContent.trim() : null;
    }

    function showToast() {
      var packName = activePackName();
      toast.textContent = packName ? 'Added to cart — ' + packName : 'Added to cart';

      toast.hidden = false;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        toast.hidden = true;
      }, TOAST_DURATION_MS);
    }

    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.action && event.action !== 'add') return;
      if (!event.promise) return;

      event.promise
        .then(function (result) {
          var detail = result && result.detail;
          if (detail && detail.didError) return;
          showToast();
        })
        .catch(function (error) {
          if (error && error.name !== 'AbortError' && window.console && console.warn) {
            console.warn('[spotmystuff-cart-toast] Event promise rejected:', error);
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
